import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import BaseElement from '../BaseElement/BaseElement';
import shallowEqual from 'fbjs/lib/shallowEqual';
import { getResizeUrlByUserPreference, cLencodeURIcomponent } from 'MyAccount/ViewDesigns/helpers/resizeImageUrlHelper';
import { getCSS } from './GallertElementStyles';
import { getPrefix, getInput, getNextNav, getPrevNav, getNavButton, getImage, getThumbnail, getThumbnailNextNav, getThumbnailPrevNav } from './GalleryElementHelper';
import classNames from 'classnames';
import {findDOMNode} from 'react-dom';
import {buildInteractiveElementsList} from 'crazyEditor/core/elements/utils/commonElementMethods';
import {getDynamicRefById} from 'crazyEditor/core/elements/utils/elementRefUtils';
import {GALLERY_THUMBNAIL_ROW_TRANSITION_DURATION} from 'crazyEditor/core/constants/editorConstants';
import { PADDING_PROP_NAMES } from 'crazyEditor/core/constants/panelConstants';
import { store } from 'crazyEditor/redux/store';
import { getIsAdmin } from 'crazyEditor/redux/modules/user/userSelectors';
import InlineStyle from 'crazyEditor/components/Elements/common/InlineStyle';

require('./GlobalStyles/GalleryElement.scss');

const THUMBNAIL_WIDTH = 100;
const THUMBNAIL_MARGIN = 20;
const THUMBNAIL_ARROW_GAP = 25;
const THUMBNAIL_COMPUTED_WIDTH = THUMBNAIL_WIDTH + THUMBNAIL_MARGIN + THUMBNAIL_ARROW_GAP;

// this function exists so that the you can access the inner getPointerElementsStyles function through the element methods (see EditBox for usage)
export function getInteractiveElements(elementId) {
  const elementRef = getDynamicRefById(elementId);
  if (elementRef) {
    return elementRef.getInteractiveElements();
  }
  return [];
}

export function refreshInteractiveElementsList(elementId, onComplete) {
  const elementRef = getDynamicRefById(elementId);
  if (elementRef) {
    _.delay(elementRef.refreshInteractiveElementsList, GALLERY_THUMBNAIL_ROW_TRANSITION_DURATION + 50, onComplete);
  }
}

export default class GalleryElement extends Component {
  componentWillMount() {
    this.uniqueId = this.props.id;
  }

  componentDidMount(prevProps) {

    this.refreshInteractiveElementsList();
    const {list} = this.props.data;
    if (_.get(prevProps, 'data.list.length') !== list.length) {
      for (let i = 0; i < list.length; i++) {
        if (_.get(this.refs[`image${i}`], 'checked') && _.get(list[i], 'id')) {
          this.checkedIndex = list[i].id;
          break;
        }
      }
      if (!this.checkedIndex) {
        _.set(this, 'refs.image0.checked', true);
        if (_.get(list[0], 'id')) {
          this.checkedIndex = list[0].id;
        }
      }
    }
  }

  shouldComponentUpdate(nextProps) {
    return !shallowEqual(this.props, nextProps);
  }

  componentDidUpdate = _.throttle(this.componentDidMount, 250);

  // get styles of elements that should have a cursor: pointer style
  getInteractiveElements = () => {
    return this.interactiveElements;
  };

  getImageList() {
    const {publish, data} = this.props;
    const {maxImages, startIndex, imageTag, firstImageTag} = this.props.data.templateTagData || {};
    let {list} = this.props.data;
    if (maxImages) {
      if (_.isEmpty(this.props.data.listingData) && !getIsAdmin(store.getState() /* THIS USAGE OF STORE SHOULD NOT SET AN EXAMPLE */)) { // Placeholder Gallery should render normal for admin user so the renders will have the images.
        if (publish) { /* integrations scope */
          list = _.range(startIndex, maxImages + startIndex).map(index => (imageTag.replace('###', `${index}`)));
          if (firstImageTag) {
            list.splice(0, 0, firstImageTag);
            list.pop();
          }
        } else {
          if (data.bulkReviseEnabled) {
            list = _.range(1, 1 + maxImages).map(index => `https://misc.crazylister.com/bulkPlaceholders/BulkPlaceholder${index}.svg`);
          } else {
            list = _.range(1, 1 + maxImages).map(index => `https://misc.crazylister.com/placeHolders/imagePlaeHolder${index}.svg`);
          }
        }
      } else {
        list = list.slice(startIndex, maxImages + startIndex);
      }
    }
    return list;
  }

  getShowDottedNav() {
    const {data} = this.props;
    let { showDottedNav } = data;
    if (data.templateTag && !data.bulkReviseEnabled) {
      showDottedNav = false;
    }
    return showDottedNav;
  }

  getShowThumbnails() {
    const {data} = this.props;
    let { showThumbnails } = data;
    if (data.templateTag && !data.bulkReviseEnabled) {
      showThumbnails = false;
    }
    return showThumbnails;
  }

  getImageHeight() {
    const showDottedNav = this.getShowDottedNav();
    const showThumbnails = this.getShowThumbnails();
    let heightReduction = 0;
    if (showDottedNav) {
      heightReduction = 66;
    } else if (showThumbnails) {
      heightReduction = 95;
    }
    return `calc(100% - ${heightReduction}px)`;
  }

  refreshInteractiveElementsList = (onComplete) => {
    let interactiveElements = [];
    const wrapper = findDOMNode(this.refs.galleryElement);
    if (wrapper) {
      interactiveElements = buildInteractiveElementsList(wrapper);
      if (interactiveElements.length > 0) {
        this.interactiveElements = interactiveElements;
        if (onComplete) {
          onComplete();
        }
      }
    }
  };

  prepareGalleryItems(list, publish, layout, isPreviewMode, alwaysShowNavArrow, compProps, isQuickPreviewMode) {
    const inputList = [];
    const prevNavList = [];
    const nextNavList = [];
    const navButtonList = [];
    const imageList = [];
    const thumbnailList = [];
    const showNavArrow = (!isPreviewMode && !publish) || alwaysShowNavArrow;

    const height = this.getImageHeight();
    list.forEach((item, index) => {
      const slideId = getPrefix(`slide${index + 1}-${this.uniqueId}`);
      let src = cLencodeURIcomponent(item);

      if (publish || (isPreviewMode && !isQuickPreviewMode)) {
        let {height} = layout;
        const {desktopId} = this.props;
        if (desktopId) {
          height *= 3;
        }
        src = getResizeUrlByUserPreference(src, {height}, true);
      }

      inputList.push(
        getInput({
          id: slideId,
          ref: `image${index}`,
          name: getPrefix(`slides-${this.uniqueId}`),
          defaultChecked: index === 0,
          key: `input${index + 1}-${this.uniqueId}`
        })
      );

      nextNavList.push(
        getNextNav({
          htmlFor: slideId,
          key: `nextNav${index + 1}-${this.uniqueId}`,
          showArrow: showNavArrow
        })
      );

      prevNavList.push(
        getPrevNav({
          htmlFor: slideId,
          key: `prevNav${index + 1}-${this.uniqueId}`,
          showArrow: showNavArrow
        })
      );

      navButtonList.push(
        getNavButton({
          htmlFor: slideId,
          key: `navButton${index + 1}-${this.uniqueId}`
        })
      );

      imageList.push(
        getImage({
          id: slideId,
          src,
          key: `image${index + 1}-${this.uniqueId}`,
          ..._.pick(compProps, PADDING_PROP_NAMES),
          height,
        })
      );

      thumbnailList.push(
        getThumbnail({
          id: slideId,
          src,
          key: `thumbnail${index + 1}-${this.uniqueId}`
        })
      );
    });

    return {inputList, prevNavList, nextNavList, navButtonList, imageList, thumbnailList};
  }

  prepareGalleryThumbnails(thumbnailList, layout) {
    const thumbnailsPrevNavList = [];
    const thumbnailsNextNavList = [];
    const thumbnailRows = {};
    const galleryWidth = parseInt(layout.width, 10);
    const itemsPerRow = Math.floor(galleryWidth / THUMBNAIL_COMPUTED_WIDTH) || 1;
    const rows = Math.ceil(thumbnailList.length / itemsPerRow);

    for (let i = 0; i < rows; i++) {
      const thumbnailRowId = getPrefix(`thumbnailRow${i}-${this.uniqueId}`);
      const thumbnailNextArrowFor = getPrefix(`slide${((i + 1) * itemsPerRow) % (itemsPerRow * rows) + 1}-${this.uniqueId}`);
      let thumbnailPrevArrowFor = getPrefix(`slide${(i * itemsPerRow)}-${this.uniqueId}`);
      if (i === 0) {
        thumbnailPrevArrowFor = getPrefix(`slide${thumbnailList.length}-${this.uniqueId}`);
      }

      thumbnailsNextNavList.push(
        getThumbnailNextNav({
          htmlFor: thumbnailNextArrowFor,
          key: `nextThumbnailNav${i}-${this.uniqueId}`
        })
      );

      thumbnailsPrevNavList.push(
        getThumbnailPrevNav({
          htmlFor: thumbnailPrevArrowFor,
          key: `prevThumbnailNav${i}-${this.uniqueId}`
        })
      );
      thumbnailRows[thumbnailRowId] = thumbnailList.slice(itemsPerRow * i, itemsPerRow * (i + 1));
    }
    return {thumbnailsPrevNavList, thumbnailsNextNavList, thumbnailRows, itemsPerRow};

  }

  render() {
    const { publish, layout, isPreviewMode, compProps, data, id, isQuickPreviewMode } = this.props;
    let { alwaysShowNavArrow } = data;
    const showDottedNav = this.getShowDottedNav();
    const showThumbnails = this.getShowThumbnails();
    if (!showDottedNav && !showThumbnails) {
      alwaysShowNavArrow = true;
    }
    const list = this.getImageList();
    const { inputList, prevNavList, nextNavList, navButtonList, imageList, thumbnailList } =
      this.prepareGalleryItems(list, publish, layout, isPreviewMode, alwaysShowNavArrow, compProps, isQuickPreviewMode);
    const { thumbnailsPrevNavList, thumbnailsNextNavList, thumbnailRows, itemsPerRow } = this.prepareGalleryThumbnails(thumbnailList, layout);
    const thumbnailRowSize = _.size(thumbnailRows);
    return (
      <BaseElement {...this.props} ref="galleryElement">
        <InlineStyle css={getCSS(id, this.uniqueId, list.length, thumbnailRowSize, itemsPerRow, compProps, this.getImageHeight(), _.get(data, 'templateTagData.imageCountTag'))}/>
        <div
          className={classNames({
            [getPrefix('wrapper')]: true,
            [getPrefix('wrapper-show-thumbnails')]: showThumbnails,
            [getPrefix('wrapper-show-dots')]: showDottedNav})}>
          {inputList}
          <div className={getPrefix('slider-content')}>{imageList}</div>
          <div className={getPrefix('slider-arrow-nav')}>{prevNavList}</div>
          <div className={getPrefix('slider-arrow-nav')}>{nextNavList}</div>
          {(_.isUndefined(showDottedNav) || showDottedNav) &&
          <div className={getPrefix('slider-nav')} data-interactive="true">{navButtonList}</div>}
          {(_.isUndefined(showThumbnails) || showThumbnails) && thumbnailRowSize > 1 &&
          <div className={getPrefix('slider-arrow-nav-thumbnails')}>{thumbnailsPrevNavList}</div>}
          {(_.isUndefined(showThumbnails) || showThumbnails) && thumbnailRowSize > 1 &&
          <div className={getPrefix('slider-arrow-nav-thumbnails')}>{thumbnailsNextNavList}</div>}
          {(_.isUndefined(showThumbnails) || showThumbnails) &&
          <div className={getPrefix('slider-content-thumbnails')} data-interactive="true">{
            _.map(thumbnailRows, (thumbnailRow, thumbnailRowId) =>
              <div
                key={thumbnailRowId}
                className={`${getPrefix('thumbnail-row')} ${thumbnailRowId}`}
                style={{transition: GALLERY_THUMBNAIL_ROW_TRANSITION_DURATION + 'ms ease-in-out all'}}>{_.map(thumbnailRow, (row) => row)}</div>)
          }</div>
          }
        </div>
      </BaseElement>
    );
  }
}

GalleryElement.propTypes = {
  id: PropTypes.string.isRequired,
  layout: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired
  }),
  data: PropTypes.shape({
    list: PropTypes.array,
    compProps: PropTypes.object
  }),
  publish: PropTypes.bool
};